<div class="container mt-3">
  <div class="card shadow-mm">
    <div class="card-header bg-primary text-white">
      <h4 class="mb-0">MAINTENANCE TICKET FORM</h4>
    </div>

    <div class="card-body">
      <form>
        <div class="row g-3">

          <!-- Plant -->
          <div class="col-md-6">
            <label class="form-label">Plant</label>
            <select class="form-select form-select-mm"
                    [(ngModel)]="ticket.MT_Plant"
                    name="Plant">
              <option value="">-- Select --</option>
              <option value="Bushing">Bushing</option>
              <option value="Half Bearing">Half Bearing</option>
            </select>
          </div>

          <!-- Shift -->
          <div class="col-md-6">
            <label class="form-label">Shift</label>
            <select class="form-select form-select-mm"
                    [(ngModel)]="ticket.MT_Shift"
                    name="Shift">
              <option value="">-- Select --</option>
              <option value="A">A</option>
              <option value="B">B</option>
              <option value="C">C</option>
              <option value="G">G</option>
            </select>
          </div>

          <!-- Line -->
          <div class="col-md-6">
            <label class="form-label">Line</label>
            <select class="form-select form-select-mm"
                    [(ngModel)]="ticket.MT_Line"
                    name="Line">
              <option value="">-- Select --</option>
              <option *ngFor="let l of lines" [value]="l">{{ l }}</option>
            </select>
          </div>

          <!-- Machine -->
          <div class="col-md-6">
            <label class="form-label">Machine</label>
            <select class="form-select form-select-mm"
                    [(ngModel)]="ticket.MT_Machine"
                    name="MT_Machine">
              <option value="">-- Select --</option>
              <option *ngFor="let m of machines" [value]="m">{{ m }}</option>
            </select>
          </div>

          <!-- Type of Maintenance -->
          <div class="col-md-6">
            <label class="form-label">Type of Maintenance</label>
            <select class="form-select form-select-mm"
                    [(ngModel)]="ticket.MT_MaintenanceType"
                    name="MT_MaintenanceType">
              <option value="">-- Select --</option>
              <option value="Plan">Plan</option>
              <option value="Breakdown">Breakdown</option>
              <option value="Setup Time">Setup Time</option>
              <option value="Tool Changing Time">Tool Changing Time</option>
              <option value="Manual">Manual</option>
              <option value="Others">Others</option>
            </select>
          </div>

          <!-- Ticket Open -->
          <div class="col-md-6">
            <label class="form-label">Ticket Open</label>
               <input id="MT_TicketOpen" type="date" #OD_Dateofjoin class="form-control form-control-mm" [(ngModel)]="ticket.MT_TicketOpen" name="MT_TicketOpen">
           
          </div>

          <!-- Requested By -->
          <div class="col-md-6">
            <label class="form-label">Requested By</label>
            <input type="text"
                   class="form-control form-control-mm"
                   [(ngModel)]="ticket.MT_RequestedBy"
                   name="MT_RequestedBy">
          </div>

          <!-- Problem Description -->
          <div class="col-md-12">
            <label class="form-label">Problem Description</label>
            <textarea rows="3"
                      class="form-control form-control-mm"
                      [(ngModel)]="ticket.MT_ProblemDescription"
                      name="MT_ProblemDescription"></textarea>
          </div>

          <!-- Analysed By -->
          <div class="col-md-6">
            <label class="form-label">Analysed By</label>
            <select class="form-select form-select-mm"
                    [(ngModel)]="ticket.MT_AnalysedBy"
                    name="MT_AnalysedBy">
              <option value="">-- Select Technician --</option>
              <option *ngFor="let t of technicians" [value]="t">{{ t }}</option>
            </select>
          </div>

          <!-- Action -->
          <div class="col-md-12">
            <label class="form-label">Action</label>
            <textarea rows="3"
                      class="form-control form-control-mm"
                      [(ngModel)]="ticket.MT_ActionTaken"
                      name="MT_ActionTaken"></textarea>
          </div>

          <!-- Accepted By -->
          <div class="col-md-6">
            <label class="form-label">Accepted By</label>
            <select class="form-select form-select-mm"
                    [(ngModel)]="ticket.MT_AcceptedBy"
                    name="MT_AcceptedBy">
              <option value="">-- Select Technician --</option>
              <option *ngFor="let t of technicians" [value]="t">{{ t }}</option>
            </select>
          </div>

          <!-- Yes / No Dropdowns -->
          <div class="col-md-6" *ngFor="let field of yesNoFields">
            <label class="form-label">{{ field.label }}</label>
            <select class="form-select form-select-mm"
                    [(ngModel)]="ticket[field.key]"
                    [name]="field.key">
              <option value="">-- Select --</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>

          <!-- Confirmed By -->
          <div class="col-md-6">
            <label class="form-label">Confirmed By</label>
            <input type="text"
                   class="form-control form-control-mm"
                   [(ngModel)]="ticket.MT_ConfirmedBy"
                   name="MT_ConfirmedBy">
          </div>

          <!-- Completed By -->
          <div class="col-md-6">
            <label class="form-label">Completed By</label>
            <select class="form-select form-select-mm"
                    [(ngModel)]="ticket.MT_CompletedBy"
                    name="MT_CompletedBy">
              <option value="">-- Select Technician --</option>
              <option *ngFor="let t of technicians" [value]="t">{{ t }}</option>
            </select>
          </div>

          <!-- Ticket Closed -->
          <div class="col-md-6">
            <label class="form-label">Ticket Closed</label>
            <input type="date"
                   class="form-control form-control-mm"
                   [(ngModel)]="ticket.MT_TicketClosed"
                   name="MT_TicketClosed"
                   readonly>
          </div>

          <!-- Durations -->
          <div class="col-md-6" >
            <label class="form-label">Total Duration</label>
            <input type="text"
                   class="form-control form-control-mm"
                   [(ngModel)]="ticket.MT_TotalDuration"
                   name="MT_TotalDuration">
          </div>
          <div class="col-md-6" >
            <label class="form-label">Operator Time Duration</label>
            <input type="text"
                   class="form-control form-control-mm"
                   [(ngModel)]="ticket.MT_OperatorTimeDuration"
                   name="MT_OperatorTimeDuration">
          </div>
          <div class="col-md-6" >
            <label class="form-label">PED Time Duration</label>
            <input type="text"
                   class="form-control form-control-mm"
                   [(ngModel)]="ticket.MT_PEDTimeDuration"
                   name="MT_PEDTimeDuration">
          </div>
          <div class="col-md-6" >
            <label class="form-label">Maintenance Time Duration</label>
            <input type="text"
                   class="form-control form-control-mm"
                   [(ngModel)]="ticket.MT_MaintenanceTimeDuration"
                   name="MT_MaintenanceTimeDuration">
          </div>


          <!-- Submit -->
          <div class="col-12">
            <div class="d-grid mt-4">
              <button class="btn btn-primary btn-lg"
                      type="button"
                      (click)="Onsubmit()">
                Submit Ticket
              </button>
            </div>
          </div>

        </div>
      </form>
    </div>
  </div>
</div>
